import { render } from "./loginWrapper.vue?vue&type=template&id=1cfa10ed&scoped=true"
import script from "./loginWrapper.vue?vue&type=script&lang=js"
export * from "./loginWrapper.vue?vue&type=script&lang=js"

import "./loginWrapper.vue?vue&type=style&index=0&id=1cfa10ed&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfa10ed"]])

export default __exports__